export const translateFooter = {
  pt: {
    footer: {
      titulo: "Vamos construir algo incrível?",
      subtitulo: "Estou disponível para novas oportunidades e colaborações.",
      email: "Enviar Email",
      linkedin: "LinkedIn",
      copyright: "© 2026. Todos os direitos reservados."
    }
  },
  en: {
    footer: {
      titulo: "Let's build something amazing?",
      subtitulo: "I am available for new opportunities and collaborations.",
      email: "Send Email",
      linkedin: "LinkedIn",
      copyright: "© 2026. All rights reserved.",
    }
  }
};